"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapVerifyOtpToChallenge = void 0;
const challengeUtils_1 = require("../../../../../features/authoriser/utils/challengeUtils");
const mapVerifyOtpToChallenge = (verifyOtpResponse) => (0, challengeUtils_1.mapToChallenge)(verifyOtpResponse);
exports.mapVerifyOtpToChallenge = mapVerifyOtpToChallenge;
//# sourceMappingURL=mapper.js.map